import { useCallback, useEffect, useState } from "react";
import { PlanningItemType } from "../../../utils/enums/planning-item-type";
import { useIsMounted } from "../../../hooks/is-mounted";
import { SummaryTimeline } from "./summary-timeline";
import { convertDeliveryOrderDetailToLocalData, convertDropToLocalData, convertSimulationDeliveryDetailToLocalData, convertToLocalArticle, convertToLocalDrop, convertToLocalDropType, convertToLocalLocation } from "../../../utils/dexie/converters";

export const PlanningItemsSummaryTimeline = ({
    route,
    planningItems
}) => {
    const isMounted = useIsMounted();
    const [drops, setDrops] = useState([]);

    const init = useCallback(() => {
        const sortedPlanItems = (planningItems ?? []).sort((a, b) => a.planIndex - b.planIndex);
        const dropPlanningItems = sortedPlanItems.filter(x => x.type === PlanningItemType.DROP);

        if (isMounted()) {
            const convertedToLocalDrops = dropPlanningItems.map(x => {
                const dropId = x.payload.id;

                const convertedToLocalLocation = convertToLocalLocation(x.payload.location);
                let convertedDrop = convertToLocalDrop(x.payload, route.id, convertedToLocalLocation.id);
                let convertedDropData = convertDropToLocalData(x.payload);

                // Save the articles
                let convertedArticles = [];

                let deliveryOrder = x.payload.deliveryOrder;
                if (deliveryOrder != null && deliveryOrder.deliveryOrderDetails != null) {
                    const deliveryOrderDetails = deliveryOrder.deliveryOrderDetails.filter(deliveryOrderDetail => deliveryOrderDetail.article != null);
                    convertedArticles = deliveryOrderDetails.map(deliveryOrderDetail => {
                        let article = convertToLocalArticle(deliveryOrderDetail.article); 
                        if (article != null) {
                            article = {
                                ...article,
                                dropdetailsdata: convertDeliveryOrderDetailToLocalData(dropId, deliveryOrderDetail)
                            };
                        }

                        return article;
                    });
                }

                let simulationDelivery = x.payload.simulationDelivery;
                if (simulationDelivery != null && simulationDelivery.simulationDeliveryDetails != null) {
                    const simulationDeliveryDetails = simulationDelivery.simulationDeliveryDetails.filter(simulationDelivery => simulationDelivery.article != null);
                    convertedArticles = simulationDeliveryDetails.map(simulationDeliveryDetail => {
                        let article = convertToLocalArticle(simulationDeliveryDetail.article); 
                        if (article != null) {
                            article = {
                                ...article,
                                dropdetailsdata: convertSimulationDeliveryDetailToLocalData(dropId, simulationDeliveryDetail)
                            };
                        }

                        return article;
                    });
                }

                const convertedResult = {
                    ...convertedDrop,
                    ...convertedDropData,
                    // Add foreign key objects
                    dropType: convertToLocalDropType(x.payload.dropType),
                    location: convertedToLocalLocation,
                    // Fields which are not supported in offline mode but only used here in online-mode
                    documents: x.payload.documents,
                    onlineArticles: convertedArticles
                };

                return convertedResult;
            });

            setDrops(convertedToLocalDrops);
        }
    }, [isMounted, planningItems, route.id]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <SummaryTimeline route={route} drops={drops} isOnlineData={true} />
    );
};